// extracted by mini-css-extract-plugin
export default {"downloadBtn":"DownloadSampleSheet_downloadBtn__LyOPm"};